module.exports = __webpack_public_path__ + "static/media/envelope.1cb31f94.svg";